const isClient = typeof window === "object"

export default (name) => {
    if (isClient) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
}

export const readCookie = (query) => {
    if (!query) {
        return null
    }
    let params = {}
    const vars = query.split('&')
    for (let i = 0; i < vars.length; i += 1) {
        const pair = vars[i].split('=')
        params[pair[0]] = decodeURIComponent(pair[1])
    }
    return query ? params : null
}